import React from 'react';

export const ListDesktop = ({ children, className = '' }) => (
  <div className={`list-desktop table-responsive ${className}`.trim()}>{children}</div>
);

export const ListMobile = ({ children, className = '' }) => (
  <div className={`list-mobile ${className}`.trim()}>{children}</div>
);

export const MobileCard = ({ children, onClick, className = '' }) => {
  const clickable = Boolean(onClick);
  return (
    <div
      className={`mobile-card ${clickable ? 'mobile-card--clickable' : ''} ${className}`.trim()}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      onClick={onClick}
      onKeyDown={clickable ? (e) => e.key === 'Enter' && onClick(e) : undefined}
    >
      <div className="mobile-card-body">{children}</div>
    </div>
  );
};

export const MobileCardTop = ({ children }) => <div className="mobile-card-top">{children}</div>;

export const MobileCardTitle = ({ children }) => <div className="mobile-card-title">{children}</div>;

export const MobileCardMeta = ({ children }) => <div className="mobile-card-meta">{children}</div>;

export const MobileCardRow = ({ label, children, mono = false }) => (
  <div className="mobile-card-row">
    {label ? <span className="mobile-field-label">{label}</span> : null}
    <span className={`mobile-field-value${mono ? ' mobile-field-value--mono' : ''}`}>{children}</span>
  </div>
);

export const MobileCardFooter = ({ children }) => <div className="mobile-card-footer">{children}</div>;
